import { getEnv } from '../environment';
import request from './request';

export const getCampaigns = async () => {
  return request({
    path: `${getEnv().REACT_APP_ACE_API_URL}/api/1/campaigns/default`,
    method: 'GET',
    json: true,
  });
};

export type CustomizeCampaign = {
  campaignInfo: {
    campaignId: number;
    campaignName: string;
    campaignPhase: string;
    endDate: string;
    selectEndDate: string;
    selectStartDate: string;
    startDate: string;
  };
  numberOfQuestions: number;
  seasonCode: string;
  seasonName: string;
  userInfo: {
    customizePage: string;
    endDate: string;
    secondsRemaining: number;
    shippingCountry: string;
    startDate: string;
  };
};

export const getCustomizeCampaign = async ({
  newMember,
  campaignId,
}: {
  newMember: boolean;
  campaignId?: string;
}): Promise<CustomizeCampaign> => {
  const base = getEnv().REACT_APP_CUSTOMIZE_API_URL;
  const segment = newMember ? 'new-members/self' : 'self';
  const url = new URL(`${base}/customize/${segment}/campaign-state`);

  if (campaignId) {
    url.searchParams.set('campaignId', campaignId);
  }

  return request({ path: url.toString() }) as Promise<CustomizeCampaign>;
};
